import { ITemplateImage } from "@/services/Models";

// 要素をシャッフルする
export const shuffle = <T> (array: T[]) => {
  const out = Array.from(array);
  for (let i = out.length - 1; i > 0; i--) {
    const r = Math.floor(Math.random() * (i + 1));
    const tmp = out[i];
    out[i] = out[r];
    out[r] = tmp;
  }
  return out;
};

// 絶対パスを生成
export const toResourceUrl = (path: string) => {
  const baseURL = process.env.VUE_APP_RESOURCE_BASE_URL as string;
  if (!baseURL || !path) {
    return path;
  }
  return baseURL.replace(/\/$/, "") + "/" + path;
};

// 吹き出し有/無テンプレートの絶対パスを生成
export const frameToResourceUrl = (
  frame: ITemplateImage,
  isBalloonOn: boolean
) => {
  return toResourceUrl(isBalloonOn ? frame.balloonOn : frame.balloonOff);
};
// タイマー処理
export const microWait = async () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), 10);
  });
};
// UNIX時間から日付へ変換
export const fromUnixTime = (time: number) => new Date(time * 1000);
// 日付からUNIX時間へ変換
export const toUnixTime = (date: Date) => Math.floor(date.getTime() / 1000);
// 日付から文字列へ変換
export const yyyyMMdd = (date: Date) =>
  `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

export const yyyyMMddHHmmssSSS = (date: Date) => {
  const name =
    date.getFullYear() +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    ("0" + date.getDate()).slice(-2) +
    ("0" + date.getHours()).slice(-2) +
    ("0" + date.getMinutes()).slice(-2) +
    ("0" + date.getSeconds()).slice(-2) +
    ("00" + date.getMilliseconds()).slice(-3);
  return name;
};

// ドラッグデータの形式
export const dragDataKeyImageObject = "imageobject"; // MEMO lowercaseじゃないとダメ

export const toRelativePos = (
  baseElement: Element,
  pos: { x: number; y: number }
) => {
  // parentからの相対座標に変換
  const rect = baseElement.getBoundingClientRect();
  return {
    x: pos.x - (rect?.left ?? 0),
    y: pos.y - (rect?.top ?? 0),
  };
};

// 親Nodeを取得
export const findParent: (
  node: Node,
  predicate: (_: Node) => boolean
) => Node | undefined = (node: Node, predicate: (_: Node) => boolean) => {
  if (!node.parentNode) return;
  if (predicate(node.parentNode)) return node.parentNode;
  return findParent(node.parentNode, predicate);
};
// 子Nodeを取得
export const findChild: (
  node: Node,
  predicate: (_: Node) => boolean
) => Node | undefined = (node: Node, predicate: (_: Node) => boolean) => {
  if (!node) return;
  if (predicate(node)) return node;
  if (!node.firstChild) return node;
  return findChild(node.firstChild, predicate);
};
// 画像読み込み
export const asyncOnLoad: (_: HTMLImageElement) => Promise<void> = async (
  elm: HTMLImageElement
) => {
  if (0 < elm.naturalWidth) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    elm.onload = () => resolve();
  });
};
// リソースから画像を生成
export const makeImage = (src: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const sourceImage = new Image();
    sourceImage.onload = () => {
      resolve(sourceImage);
    };
    sourceImage.onerror = () => {
      reject("load image error");
    };
    sourceImage.src = src;
  });
};
// 受け取ったデータを平坦化して取り出す
export const flatPromise = async <T> (xs: Promise<T>[]) => {
  const vs: T[] = [];
  for (const x of xs) {
    vs.push(await x);
  }
  return vs;
};

const fr = new FileReader();
// blob要素をBase64形式の文字列に変換
export const readAsDataURL = (blob: Blob) => {
  return new Promise((res, rej) => {
    const wrapHandler = (ev: ProgressEvent<FileReader>, h: (_: FileReader) => void) => {
      fr.removeEventListener("load", loaded);
      fr.removeEventListener("error", errored);
      if (!ev.target) return;
      h(ev.target);
    }
    const loaded = (ev: ProgressEvent<FileReader>) => wrapHandler(ev, r => res(r.result));
    const errored = (ev: ProgressEvent<FileReader>) => wrapHandler(ev, r => rej(r.error));
    fr.addEventListener("load", loaded);
    fr.addEventListener("error", errored);
    fr.readAsDataURL(blob);
  });
};
// 許可された拡張子かどうか
export const isIncludeMIMEType = (dataURI: string, types: string[]) => {
  const part = dataURI.substr(0, 64);
  return types.some((t) => part.includes(t));
};

export const getBase64ImageFromUrl = async (imageUrl: string) => {
  return new Promise((resolve) =>
    fetch(imageUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          resolve(reader.result);
        });
        reader.readAsDataURL(blob);
      })
  );
};
